/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }

  // Telephony inboxes: where the agent's audio lives — 'browser' (our softphone)
  // or 'device' (their own desk phone / mobile, rung by the PBX).
  setAudioMode(inboxId, mode) {
    return axios.post(`${this.url}/${inboxId}/set_audio_mode`, {
      audio_mode: mode,
    });
  }

  getMaxStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/max_status`);
  }

  reconnectMax(inboxId) {
    return axios.post(`${this.url}/${inboxId}/max_reconnect`);
  }

  getMaxQrImage(inboxId) {
    // `_` cache-buster: the QR rotates server-side, so every poll must fetch a
    // fresh blob rather than a browser/ETag-cached (stale, expired) one.
    return axios.get(`${this.url}/${inboxId}/max_qr_image`, {
      params: { _: Date.now() },
      responseType: 'blob',
    });
  }

  validateMaxBotToken(apiToken) {
    return axios.post(`${this.url}/validate_max_bot_token`, {
      api_token: apiToken,
    });
  }

  getTelegramUserStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/telegram_user_status`);
  }

  getTelegramUserQrImage(inboxId) {
    // `_` cache-buster: the QR rotates server-side, so every poll must fetch a
    // fresh blob rather than a browser/ETag-cached (stale, expired) one.
    return axios.get(`${this.url}/${inboxId}/telegram_user_qr_image`, {
      params: { _: Date.now() },
      responseType: 'blob',
    });
  }

  submitTelegramUserPassword(inboxId, password) {
    return axios.post(`${this.url}/${inboxId}/telegram_user_password`, {
      password,
    });
  }

  // Мягкое переподключение: сессия поднимается заново без удаления .session —
  // живая оживает сама, мёртвая уходит в QR-цикл со свежим кодом.
  reauthTelegramUser(inboxId) {
    return axios.post(`${this.url}/${inboxId}/telegram_user_reauth`);
  }

  reconnectTelegramUser(inboxId) {
    return axios.post(`${this.url}/${inboxId}/telegram_user_reconnect`);
  }

  syncTelegramUserHistory(inboxId) {
    return axios.post(`${this.url}/${inboxId}/telegram_user_sync_history`);
  }

  getTelegramUserSyncStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/telegram_user_sync_status`);
  }

  getVkCallbackStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/vk_callback_status`);
  }

  fetchVkConfirmation(inboxId) {
    return axios.post(`${this.url}/${inboxId}/vk_fetch_confirmation`);
  }

  setupVkCallback(inboxId) {
    return axios.post(`${this.url}/${inboxId}/vk_setup_callback`);
  }
}

export default new Inboxes();
